<template>
  <form @submit.prevent="add">
    <form-control
      v-model="data.ticker"
      :errors="error ? error.errors.ticker : []"
      title="Ticker"
    />
    <div class="form-group">
      <label>Data Provider</label>

      <multiselect
        v-model="dataProvider"
        :options="dataProviders"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.data_provider_id) ? error.errors.data_provider_id : []).length > 0
        }"
        placeholder="Type to search"
        track-by="id"
        label="name"
        @select="(val) => { data.data_provider_id = val.id }"
      />
    </div>
    <div class="form-group">
      <label>Asset Class</label>

      <multiselect
        v-model="assetClass"
        :options="assetClassses"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.asset_class_id) ? error.errors.asset_class_id : []).length > 0
        }"
        placeholder="Type to search"
        track-by="id"
        label="name"
        @select="(val) => data.asset_class_id = val.id"
      />
    </div>
  </form>
</template>

<script>
import TickerFormMixin from './TickerFormMixin'

export default {
  mixins: [TickerFormMixin],
}
</script>
